export const ICON_LIBRARY_SEARCH_URL = 'https://api.iconify.design/search';
export const ICON_LIBRARY_ASSET_URL = (iconId) => `https://api.iconify.design/${iconId}.svg`;
export const ICON_LIBRARY_MAX_RESULTS = 24;
export const DEFAULT_CANVAS_WIDTH = 900;
export const DEFAULT_CANVAS_HEIGHT = 600;
export const DEFAULT_CANVAS_BACKGROUND = '#ffffff';
